/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events,jsx-a11y/no-autofocus */
import PropTypes from "prop-types";
import { Form, useFormikContext } from "formik";

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import makeStyles from "@material-ui/core/styles/makeStyles";

import PasswordField from "common/components/form-fields/password.component";
import loginFormStyles from "features/login-screen/login-form/views/login-form.styles";

const useStyles = makeStyles(loginFormStyles);

function PasswordForm({ onBackClick: handleBackClick }) {
  const classes = useStyles();

  const {
    isValid,
    isSubmitting,
    values: { userId },
    setErrors,
    setFieldValue,
  } = useFormikContext();

  const handleBackButtonClick = () => {
    setErrors({});
    setFieldValue("userId", "");
    setFieldValue("password", "");
    handleBackClick();
  };

  return (
    <Form className={classes.form}>
      <div className={classes.backButton} onClick={handleBackButtonClick}>
        <ArrowBackIcon />
        <Typography variant="body1">{userId}</Typography>
      </div>
      <PasswordField
        name="password"
        variant="filled"
        label="Password"
        fullWidth
        margin="normal"
        className={classes.field}
        autoFocus
      />
      <Button
        variant="contained"
        type="submit"
        fullWidth
        disabled={!isValid || isSubmitting}
        className={classes.button}
      >
        Sign in
      </Button>
    </Form>
  );
}

PasswordForm.propTypes = {
  onBackClick: PropTypes.func.isRequired,
};

export default PasswordForm;
